export type getPagedUrnsProps = (
  urns?: string[],
  urnCache?: string[]
) => string[];

export const getPagedUrns: getPagedUrnsProps = (urns = [], urnCache = []) =>
  urns.filter((urn) => !urnCache.includes(urn));
